import { PayloadAction } from '@reduxjs/toolkit';
import createSlice from '../util/createImmerlessSlice';
import { FileEditTabBarSelected } from 'src/screens/Publishers/TabBar';
import { FolderORM } from 'src/types/orms';
import { StandaloneForm } from '../selector/crm';
import type { MEETING_SUBMIT_TYPE } from 'src/components/Meeting/AddMeetingProvider';

export enum DRAWER_ENTITIES {
  EMAIL_TEMPLATE,
  USER,
  MEETING,
  ORGANIZATION,
  FILES,
  TENANT_FORM,
  CRM_FORM,
}

const DEFAULT_WIDTH = 960;

type DrawerSliceState = {
  entity?: DRAWER_ENTITIES,
  entityId?: string,
  tenantId?: string;
  isOpen?: boolean,
  orientation?: 'left' | 'right',
  selectedTab?: FileEditTabBarSelected,
  width?: number,
  keepOpen?: boolean,
  hasPendingChanges?: boolean,
  folderORM?: FolderORM,
  standaloneForm?: StandaloneForm
  autoSubmitToCRM?: boolean,
  autoSubmitToCRMSubmitType?: MEETING_SUBMIT_TYPE,
}

const initialState: DrawerSliceState = {
  entity: undefined,
  folderORM: undefined,
  entityId: undefined,
  tenantId: undefined,
  orientation: 'right',
  width: DEFAULT_WIDTH,
  isOpen: false,
  selectedTab: FileEditTabBarSelected.LABELS,
}

const drawerSlice = createSlice({
  name: 'DrawerState',
  initialState: initialState,
  reducers: {
    toggle: (state, action: PayloadAction<DrawerSliceState>) => {
      const {
        entityId,
        width,
        orientation,
        selectedTab,
        entity,
        tenantId,
        standaloneForm,
        autoSubmitToCRM,
        autoSubmitToCRMSubmitType,
        keepOpen = false,
      } = action.payload;

      const isOpen = !(state.isOpen && !keepOpen);
      const tabSelected = state.isOpen && !keepOpen
        ? FileEditTabBarSelected.LABELS
        : selectedTab ?? state.selectedTab ?? FileEditTabBarSelected.LABELS;

      return {
        ...state,
        isOpen,
        standaloneForm,
        entityId,
        tenantId,
        width: !isOpen ? DEFAULT_WIDTH : width ?? state.width ?? DEFAULT_WIDTH,
        orientation: orientation ?? state.orientation ?? initialState.orientation,
        selectedTab: tabSelected,
        entity,
        autoSubmitToCRM,
        autoSubmitToCRMSubmitType,
      }
    },
    hide: (state) => {
      return { ...state, isOpen: false, currentDocId: undefined }
    },
    setPendingChanges: (state, action: PayloadAction<DrawerSliceState>) => {
      return { ...state, hasPendingChanges: action.payload.hasPendingChanges }
    },
    clearCRMAutoSubmit: (state) => {
      return {
        ...state,
        autoSubmitToCRM: false,
        autoSubmitToCRMSubmitType: undefined,
      }
    },
  },
})

export default drawerSlice
export const drawerActions = drawerSlice.actions
